import type {
	EntriesDateScope,
	EntriesQueryScope,
	EntryStatus,
} from "@/shared/cache";
import type { EntryFilterState } from "./filters/types";

const ENTRY_STATUSES = new Set<EntryStatus>([
	"tracked",
	"reviewed",
	"exported",
	"deleted",
]);

function validStatuses(
	values: readonly string[] | undefined,
): EntryStatus[] | undefined {
	if (values === undefined) return undefined;
	return values.filter((value): value is EntryStatus =>
		ENTRY_STATUSES.has(value as EntryStatus),
	);
}

export function entryFiltersToEntriesScope(
	filters: EntryFilterState,
	date?: EntriesDateScope,
	options: {
		statuses?: readonly EntryStatus[];
		includeStatus?: boolean;
		includeFieldFilters?: boolean;
		includeAttachments?: boolean;
	} = {},
): EntriesQueryScope {
	const includeFieldFilters = options.includeFieldFilters ?? true;
	const scope: EntriesQueryScope = {
		...(date ? { date } : {}),
		includeAttachments: options.includeAttachments,
	};

	if (filters.timekeeper !== undefined)
		scope.timekeeperIds = filters.timekeeper;

	const statuses =
		options.statuses ??
		(options.includeStatus === false
			? undefined
			: validStatuses(filters.status));
	if (statuses !== undefined) scope.statuses = statuses;

	if (includeFieldFilters) {
		for (const field of [
			"application",
			"matter",
			"client",
			"billableCategory",
		] as const) {
			if (filters[field] !== undefined) scope[field] = filters[field];
		}
	}

	return scope;
}
